module.exports = __webpack_public_path__ + "img/midtop.8ecad6ce.png";